import React from "react";
import { TelegramLogo, ArrowRight } from "@phosphor-icons/react";
import { TELEGRAM_INVITE_LINK } from "../lib/social";

/**
 * Telegram channel CTA — three visual variants:
 *   - 'banner'  : large card with copy + CTA (hero / wins page)
 *   - 'pill'    : compact pill button (header / footer)
 *   - 'footer'  : tiny inline link (dashboard footer strip)
 */
export default function TelegramCTA({ variant = "banner", className = "", testId = "telegram-cta" }) {
  if (variant === "footer") {
    return (
      <a
        href={TELEGRAM_INVITE_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid={testId}
        className={"flex items-center gap-1 hover:text-pos transition " + className}
      >
        <TelegramLogo size={11} weight="fill" /> Telegram
      </a>
    );
  }
  if (variant === "pill") {
    return (
      <a
        href={TELEGRAM_INVITE_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid={testId}
        className={
          "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-sm border border-pos/40 bg-pos-soft text-pos text-[11px] font-mono uppercase tracking-widest hover:bg-pos-soft/80 transition " +
          className
        }
      >
        <TelegramLogo size={12} weight="fill" /> Join Telegram
      </a>
    );
  }
  // banner
  return (
    <a
      href={TELEGRAM_INVITE_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      className={
        "group block border border-subtle hover:border-pos/40 bg-surface rounded-sm p-4 transition " +
        className
      }
    >
      <div className="flex items-center gap-3">
        <div className="shrink-0 w-10 h-10 rounded-sm bg-pos-soft border border-pos/30 flex items-center justify-center text-pos">
          <TelegramLogo size={20} weight="fill" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-medium text-primary-fg text-sm">
            Daily wins on Telegram — free
          </div>
          <div className="text-xs text-muted-fg mt-0.5">
            Live target-hit alerts in our public channel · zero signup needed
          </div>
        </div>
        <div className="shrink-0 text-pos flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest opacity-90 group-hover:opacity-100">
          Join <ArrowRight size={11} weight="bold" />
        </div>
      </div>
    </a>
  );
}
